import type { UserRepository } from '../repository/UserRepository';
import type { UpdateUserRequest, UpdateUserResponse } from '../entity/UserTypes';

export class UpdateUserUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(request: UpdateUserRequest): Promise<UpdateUserResponse> {
    if (!request.user_id?.trim()) {
      throw new Error('user_id is required');
    }
    return this.repository.updateUser(request);
  }
}

